<template>
    <div>
        <!-- 搜索框 -->
        <a-card title="MQ信息回放">
            <!--            <a-button slot="extra" type="primary" @click="handleNewUser">新建用户</a-button>-->
            <a-form layout="inline" @submit="handleSubmit" :form="form">
                <a-form-item label="领域(domain)">
                    <a-select v-model="searchP.domain" placeholder="请选择领域" style="width:120px;" @change="domainChange">
                        <!-- <a-select-option value="BASIC">
                            前台
                        </a-select-option>
                        <a-select-option value="ENTRY">
                            中台
                        </a-select-option>
                        <a-select-option value="FPAPI">
                            基础
                        </a-select-option> -->
                        <a-select-option v-for="(value, key) in domainMap" :key="key" :value="key">
                            {{ value }}
                        </a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="主题(topic)">
                    <a-select v-model="searchP.topic" placeholder="请选择主题(topic)" style="width:120px;">
                        <a-select-option v-for="(item) in topicMaps.topic" :key="item">
                            {{ item }}
                        </a-select-option>
                    </a-select>
                </a-form-item>
                <!--                <a-form-item label="主题(topic)">-->
                <!--                    <a-input v-model="searchP.topic" placeholder="请输入主题(topic)"></a-input>-->
                <!--                </a-form-item>-->
                <a-form-item label="标签(serviceName)">

                    <a-input v-model="searchP.serviceName" placeholder="请输入标签(serviceName)"></a-input>
                </a-form-item>
                <a-form-item label="关键词">
                    <a-input v-model="searchP.searchKey" placeholder="请输入关键词"></a-input>
                </a-form-item>
                <a-form-item label="回溯消费组名称">
                    <a-select v-model="searchP.consumerGroup" placeholder="请选择回溯消费组名称" style="width:120px;">
                        <a-select-option v-for="(item) in topicMaps.RETRY" :key="item">
                            {{ item }}
                        </a-select-option>
                    </a-select>
                    <!--                    <a-input v-model="searchP.consumerGroup" placeholder="回溯消费组名称"></a-input>-->
                </a-form-item>
                <a-form-item label="开始时间">
                    <a-date-picker v-model="searchP.beginTime" :show-time="{ format: 'YYYY-MM-DD HH:mm:ss' }"
                                   format="YYYY-MM-DD HH:mm:ss" placeholder="选择开始时间"/>
                </a-form-item>
                <a-form-item label="结束时间">
                    <a-date-picker v-model="searchP.endTime" :show-time="{ format: 'YYYY-MM-DD HH:mm:ss' }"
                                   format="YYYY-MM-DD HH:mm:ss" placeholder="选择结束时间"/>
                </a-form-item>
                <a-form-item>
                    <a-button type="primary" htmlType="submit" :key="this.loading.key" @click="selectResendLogs">回放记录
                    </a-button>
                </a-form-item>
                <a-form-item>
                    <a-button :disabled="isDisabled" type="primary" htmlType="submit" :key="this.loading.key"
                              @click="searchMqInfoCount">我要回放
                    </a-button>
                </a-form-item>
                <a-form-item>
                    <a-button type="default" htmlType="submit" :key="this.loading.key" @click="handleSearchReset">重置
                    </a-button>
                </a-form-item>
            </a-form>
        </a-card>

        <!-- 消息列表 -->
        <a-table :columns="columns" :data-source="msgData" :pagination="false" :loading="tLoading"
                 rowKey="id">

            <template slot="readParams" slot-scope="text,record">

                <!-- 报文 -->
                <a-icon style="color:#1890ff;" size="large" type="file-text" @click="handleParams(record)"/>
            </template>
            <template slot="readProgress" slot-scope="text,record">
                <a-progress v-if="record.status==1" type="dashboard" :width="60"
                            :percent="  parseFloat((record.currentcount / record.resendcount * 100).toFixed(1))"/>
                <span v-else-if="record.status==2"> 已完成</span>
                <span v-else-if="record.status==0"> 准备执行</span>
                <span v-else-if="record.status==-1"> 错误结束</span>
            </template>
        </a-table>
        <a-pagination class="my_pagenation" v-model="searchP.page" :total="searchP.total" @change="handlePageChange"
                      show-less-items show-quick-jumper/>
        <a-modal v-model="modalVisible" title="消息报文" @ok="handleOk">
            <a-tabs default-active-key="1">
                <a-tab-pane key="1" tab="请求参数">
                    <json-viewer
                        :value="currentRequest"
                        :expand-depth=5
                        copyable
                        boxed
                        sort></json-viewer>
                </a-tab-pane>
                <a-tab-pane key="2" tab="响应结果">
                    <json-viewer
                        :value="currentResponse"
                        :expand-depth=5
                        copyable
                        boxed
                        sort></json-viewer>
                </a-tab-pane>

            </a-tabs>
        </a-modal>
        <a-modal v-model="confirmVisible" title="Basic Modal" @ok="handleConfirmOk">
            {{ confirmMsg }}
        </a-modal>
    </div>
</template>
<script>

import JsonViewer from "vue-json-viewer"

const columns = [
    {
        title: "记录ID",
        dataIndex: 'id',
        width: 100,
        align: "center",

    },
    {
        title: "执行号",
        dataIndex: 'resendno',
        width: 100,
        align: "center",

    },
    {
        title: '分次执行号',
        dataIndex: 'subresendno',
        align: 'center',
        width: 120,
        ellipsises: true
    },
    {
        title: '回放总数据量',
        dataIndex: 'resendtotal',
        align: 'center',
        width: 120,
        ellipsises: true
    },
    {
        title: '分次回放数据量',
        dataIndex: 'resendcount',
        align: 'center',
        width: 120,
        ellipsises: true
    },
    {
        title: '回放时间',
        dataIndex: 'createtime',
        align: 'center',
        width: 120,
        ellipsises: true
    },
    {
        title: '更新时间',
        dataIndex: 'updatetime',
        align: 'center',
        width: 120,
        ellipsises: true
    },

    {
        title: "消息报文",
        width: 120,
        scopedSlots: {customRender: 'readParams'},
        align: "center",
        ellipsis: true,
    },
    {
        title: "当前进度",
        width: 120,
        scopedSlots: {customRender: 'readProgress'},
        align: "center",
        ellipsis: true,
    },
    // ,
    // {
    //     title: '消息体',
    //     dataIndex: 'body',
    //     align: 'center',
    //     width: 120,
    //     ellipsises: true
    // }
];
const msgData = [];

export default {
    data() {
        return {
            form: this.$form.createForm(this),
            msgData,
            columns,
            searchP: {
                topic: '',
                serviceName: '',
                consumerGroup: '',
                endTime: '',
                beginTime: '',
                maxNum: 100,
                total: 0,
                pageSize: 0,
                page: undefined,
            },
            tLoading: false,
            currentRequest: "",
            currentResponse: "",
            modalVisible: false,
            confirmVisible: false,
            confirmMsg: "",
            isDisabled: false,
            topicMaps: {
                topic: [],
                DLQ: [],
                RETRY: []

            },
            domainMap:{
            }
        };
    },
    methods: {
        domainChange() {
            if (this.searchP.domain === "") {
                this.message.info("请先选择领域!")
            } else {
                this.searchTopics();
            }

        },
        handleOk() {
            this.modalVisible = false;
        },
        queryDomainMap(){
            let that = this;
            this.$store.dispatch({
                type: "mqinfo/queryDomainMap",
                params: {},
                timeout: 5000,
            }).then((res) => {
                console.log(res);
                if (res.data.data) {
                    that.domainMap = res.data.data;
                }
            })
        },
        searchTopics() {
            let that = this;
            this.$store.dispatch({
                type: "mqinfo/searchTopics",
                params: {
                    domain: that.searchP.domain
                },
                timeout: 5000,
            }).then((res) => {
                that.tLoading = true;
                that.isDisabled = false;
                console.log(res);
                if (res.data.data && res.data.data.topic) {
                    that.topicMaps.topic = res.data.data.topic.split(',');
                    that.topicMaps.RETRY = res.data.data.RETRY.split(',');
                }
                that.tLoading = false;
            })
        }
        ,
        handleParams(item) {
            this.modalVisible = true;
            let c_params = {
                resendno: item.resendno,
                urlparams: false,
            }
            this.$store.dispatch({
                type: "mqinfo/selectResendLogsDetailOne",
                params: c_params,
                timeout: 50000,
            }).then((res) => {
                this.tLoading = true;
                this.isDisabled = false;
                console.log(res);
                if (res.data.data) {
                    //
                    try {
                        this.currentRequest = JSON.parse(res.data.data.resendprarms);
                        this.currentResponse = JSON.parse(res.data.data.resendlog);
                    } catch (error) {
                        this.currentRequest = res.data.data.resendprarms;
                        this.currentResponse = res.data.data.resendlog;
                    }
                }
                this.tLoading = false;
            })


        },

        handleConfirmOk() {
            this.isDisabled = true;
            this.resendMessage();
            this.confirmVisible = false;

        },
        resendMessage() {
            let c_params = {
                ...this.searchP,
                urlparams: false,
            }
            c_params.endTime = this.searchP.endTime ? this.dateFormat('YYYY-mm-dd HH:MM:SS', new Date(this.searchP.endTime)) : '';
            c_params.beginTime = this.searchP.beginTime ? this.dateFormat('YYYY-mm-dd HH:MM:SS', new Date(this.searchP.beginTime)) : '';
            this.$store.dispatch({
                type: "mqinfo/resendMessage",
                params: c_params,
                timeout: 50000,
            }).then((res) => {
                this.tLoading = true;
                this.isDisabled = false;
                console.log(res);
                if (res.data.data) {
                    this.message.success("【" + res.data.data.total + "】条消息回放成功!")
                    this.selectResendLogs();
                }
                this.tLoading = false;
            })
        },
        selectResendLogs() {
            let c_params = {
                ...this.searchP,
                urlparams: false,
            }
            c_params.endTime = this.searchP.endTime ? this.dateFormat('YYYY-mm-dd HH:MM:SS', new Date(this.searchP.endTime)) : '';
            c_params.beginTime = this.searchP.beginTime ? this.dateFormat('YYYY-mm-dd HH:MM:SS', new Date(this.searchP.beginTime)) : '';
            this.$store.dispatch({
                type: "mqinfo/selectResendLogs",
                params: c_params
            }).then((res) => {
                this.tLoading = true;
                console.log(res);
                if (res.data.data) {
                    let result = res.data.data;
                    this.msgData = result.list;
                    this.searchP.total = result.totalRecords;
                    this.searchP.pageSize = result.pageSize;
                    this.searchP.page = result.page;
                }
                this.tLoading = false;
                // this.searchP.pageSize = this.msgData.pageSize;
                // this.searchP.page = this.msgData.page;
            })
        }, searchMqInfoCount() {
            let c_params = {
                ...this.searchP,
                urlparams: false,
                timeout: 50000,
            }
            c_params.endTime = this.searchP.endTime ? this.dateFormat('YYYY-mm-dd HH:MM:SS', new Date(this.searchP.endTime)) : '';
            c_params.beginTime = this.searchP.beginTime ? this.dateFormat('YYYY-mm-dd HH:MM:SS', new Date(this.searchP.beginTime)) : '';
            this.$store.dispatch({
                type: "mqinfo/searchMqInfoCount",
                params: c_params
            }).then((res) => {
                this.tLoading = true;
                console.log(res);
                if (res.data.data && res.data.data.total) {
                    // message.success(res.data)
                    this.confirmMsg = "是否确认回放【" + res.data.data.total + "】条消息?";
                    this.confirmVisible = true;
                }
                this.tLoading = false;

            })
        },
        handlePageChange(c_p) {
            this.searchP.page = c_p;
            this.updateRoute();
        }
        ,
        updateRoute() {
            this.$router.push({
                query: {
                    topic: this.searchP.topic,
                    serviceName: this.searchP.serviceName,
                    searchKey: this.searchP.searchKey,
                    consumerGroup: this.searchP.consumerGroup,
                    beginTime: this.searchP.beginTime,
                    endTime: this.searchP.endTime,
                    maxNum: this.searchP.maxNum,
                    page: this.searchP.page,
                }
            });
        }
        ,
        handleSearchReset() {
            this.searchP.page = 1;
            this.searchP.topic = 'MQ_TEST_A1';
            this.searchP.serviceName = 'ums-common-service';
            this.searchP.searchKey = '';
            this.searchP.consumerGroup = 'hs_ums_p';
            this.searchP.beginTime = '';
            this.searchP.endTime = '';
            this.updateRoute();
        }
        ,
        handleNewUser() {
            this.$router.push({
                path: "addUser",
            });
        }
        ,
        handleSubmit(e) {
            e.preventDefault();
            this.searchP.page = 1
            this.updateRoute()
        },
        dateFormat(fmt, date) {
            let ret;
            const opt = {
                "Y+": date.getFullYear().toString(),        // 年
                "m+": (date.getMonth() + 1).toString(),     // 月
                "d+": date.getDate().toString(),            // 日
                "H+": date.getHours().toString(),           // 时
                "M+": date.getMinutes().toString(),         // 分
                "S+": date.getSeconds().toString()          // 秒
                // 有其他格式化字符需求可以继续添加，必须转化成字符串
            };
            for (let k in opt) {
                ret = new RegExp("(" + k + ")").exec(fmt);
                if (ret) {
                    fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
                }
            }
            return fmt;
        }
        ,
    },

    components: {
        JsonViewer,
    }
    ,
    watch: {
        '$route'() {
            this.$router.go(0);
        }
    }
    ,
    mounted() {
        let query = this.$route.query;
        this.searchP.topic = query.topic ? query.topic : '';
        this.searchP.serviceName = query.serviceName ? query.serviceName : '';
        this.searchP.searchKey = query.searchKey ? query.searchKey : '';
        this.searchP.consumerGroup = query.consumerGroup ? query.consumerGroup : '';
        this.searchP.beginTime = query.beginTime ? query.beginTime : '';
        this.searchP.endTime = query.endTime ? query.endTime : '';
        this.searchP.maxNum = query.maxNum ? query.maxNum : 100;
        this.searchP.page = query.page ? +query.page : 1;
        this.selectResendLogs();
        this.searchTopics();
        this.queryDomainMap();
    }
}
;
</script>
<style scoped>
.editable-row-operations a {
    margin-right: 8px;
}

td {
    padding: 10px 10px;
}
</style>
